import { lazy } from "react"

const UserPage$$__react__lazy__component = lazy(() => 
    import("./UserPage__original__module.mjs")
        .then(module => module.get_$$UserPage$$UserPage$$react__component$$1if85m5de2lfw())
        .then(component => ({ default: component }))
)

export const get_$$UserPage$$UserPage$$react__component$$1if85m5de2lfw = () => UserPage$$__react__lazy__component